var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-editor',{attrs:{"editor-toolbar":_vm.custom_toolbar,"editor-options":_vm.editor_options},model:{value:(_vm.local_value),callback:function ($$v) {_vm.local_value=$$v},expression:"local_value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }